if($(window).width() >= '749'){
$(".tab_content").hide();
		$(".tab_content:first").show();

		/* if in tab mode */
		$("ul.tabs li").click(function() {
		    
		  $(".tab_content").hide();
		  var activeTab = $(this).attr("rel"); 
		  $("#"+activeTab).fadeIn();		
		    
		  $("ul.tabs li").removeClass("active");
		  $(this).addClass("active");

		  $(".tab_drawer_heading").removeClass("d_active");
		  $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
		  
		});
}  
		/* if in drawer mode */
jQuery(".tab_drawer_heading").click(function(){
  if(jQuery(this).hasClass("show"))
        {
          jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
  else
        {
          jQuery(".tab_drawer_heading").removeClass("show");
          jQuery(".tab_drawer_heading").next().slideUp();
          jQuery(this).addClass("show");jQuery(this).next().slideDown();
        }
});
  
